import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { DataPill } from './DataPill.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["dataPills"];
var StyledGridContainer = styled.div.withConfig({
  displayName: "DataPoint__StyledGridContainer",
  componentId: "sc-18hahq9-0"
})(["&&{display:flex;flex-wrap:wrap;gap:8px;min-width:288px;max-width:328px;}"]);
var DataPoint = /*#__PURE__*/React.forwardRef(function DataPoint2(props, ref) {
  var dataPills = props.dataPills,
    rest = _objectWithoutProperties(props, _excluded);
  var dataPillList = dataPills.map(function (dataPill, index) {
    return /*#__PURE__*/jsx(DataPill, _objectSpread({}, dataPill), index);
  });
  return /*#__PURE__*/jsx(StyledGridContainer, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: dataPillList
  }));
});
DataPoint.displayName = "DataPoint";

export { DataPoint };
